.embeddedServiceHelpButton .helpButton .uiButton {
  background-color: #2e5276;
  font-family: 'Arial', sans-serif;
}
.embeddedServiceHelpButton .helpButton .uiButton:focus {
  outline: 1px solid #2e5276;
}
